import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger,
    mergeClasses
} from '@fluentui/react-components';
import { IBasicCancelProceedPopupProps } from './BasicCancelProceedPopup.types';
import { useBasicCancelProceedPopupsStyles } from './BasicCancelProceedPopup.styles';

const BasicCancelProceedPopup = (props: IBasicCancelProceedPopupProps) => {
    const { showPopup, popupHeader, popupText, onDialogClose } = props;
    const styles = useBasicCancelProceedPopupsStyles();

    return (
        <Dialog open={showPopup}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle as='h2' className={styles.header}>
                        {popupHeader}
                    </DialogTitle>
                    <DialogContent>
                        <p>{popupText}</p>
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger>
                            <Button
                                onClick={() => onDialogClose(false)}
                                className={mergeClasses(styles.buttons, styles.cancelButton)}
                            >
                                Cancel
                            </Button>
                        </DialogTrigger>
                        <Button
                            onClick={() => onDialogClose(true)}
                            className={mergeClasses(styles.buttons, styles.proceedButton)}
                        >
                            Proceed
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export default BasicCancelProceedPopup;
